import InnoIcons from "InnoUI/innoicons";
import theme from "@theme";
import styled from "@emotion/styled";

const InputContiner = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  width: 50%;
`;

const SearchIcon = styled(InnoIcons.SearchIcon)`
  position: absolute;
  left: 10px;
  color: #afafaf;
  font-size: 20px;
`;

const InputStyle = styled.input`
  width: 100%;
  height: 32px;
  padding: 8px 8px 8px 35px;
  font-size: 13px;
  border: 1px solid ${theme.colors.themeColor};
  border-radius: 4px;
  &:focus {
    outline: none;
    border-color: #ccc;
  }
  ,
  &::placeholder {
    color: #afafaf;
  }
`;

const Container = styled.div`
  overflow-y: auto;
  max-height: 600px;
  padding: 0px 20px 20px 20px;
  width: 100%;

  ::-webkit-scrollbar {
    width: 6px;
  }

  ::-webkit-scrollbar-track {
    background: ${theme.colors.bordertask};
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb {
    background: ${theme.colors.themeColor};
    border-radius: 10px;
  }
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

const Th = styled.th`
  text-align: left;
  font-size: 13px;
  padding-left: 5px;
`;

const ThRole = styled.th`
  text-align: left;
  padding: 10px 10px 10px 0px;
  display: flex;
  gap: 10px;
  text-align: center;
  align-items: center;
  font-size: 13px;
`;

const Trheader = styled.tr`
  border-bottom: 2px solid #ddd;
`;
const Tr = styled.tr``;

const TdRole = styled.td`
  padding: 0px 6px 0px 6px;
  border-bottom: 1px solid #ddd;
  font-size: 13px;
`;

const Td = styled.td`
  padding: 0px 6px 0px 6px;
  border-bottom: 1px solid #ddd;
`;

const Checkbox = styled.input`
  margin: 0;
`;

const SwapVertIcon = styled(InnoIcons.SwapVertIcon)`
  cursor: pointer;
  font-size: 16px;
`;

const Thead = styled.thead``;

const Tbody = styled.tbody``;

const DrawerTitlesContainer = styled.div`
  display: flex;
  background: ${theme.gradient.themeGradient};
  align-items: center;
  justify-content: space-between;
  padding: 0px 10px 0px 20px;
  height: 50px;
  position: sticky;
  top: 0;
  z-index: 1000;
`;

const CloseIcon = styled.p`
  cursor: pointer;
  color: white;
`;

const DrawerTitles = styled.div`
  font-size: 17px;
  color: white;
  font-weight: normal;
  align-items: center;
  display: flex;
  text-align: center;
`;

const ThContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
`;

const ProjectFilterContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

const SelectStyle = styled.select`
  padding: 6px 12px;
  border: 1px solid #d0d5dd;
  border-radius: 6px;
  font-size: 14px;
  color: #344054;
  background-color: #fff;
  cursor: pointer;
  max-height: 150px; /* doesn't affect <select> directly */
  overflow-y: auto;

  /* This is only for browsers that render dropdown with OS styles */
  option {
    overflow-y: auto;
    max-height: 150px;
  }

  &:focus {
    outline: none;
    border-color: #2684ff;
    box-shadow: 0 0 0 2px rgba(38, 132, 255, 0.2);
  }
`;

const TitleConatiner = styled.div`
  padding: 0px 20px 20px 20px;
`;

const Title = styled.p`
  font-weight: bold;
  font-size: 13px;
  margin: 0px;
  padding: 0px;
`;

const Description = styled.p`
  font-size: 12px;
  margin: 0px;
  padding: 0px;
`;

const SC = {
  InputContiner,
  SearchIcon,
  InputStyle,
  Container,
  Table,
  Th,
  Tr,
  Td,
  Checkbox,
  ThRole,
  SwapVertIcon,
  Thead,
  Tbody,
  TdRole,
  DrawerTitlesContainer,
  CloseIcon,
  DrawerTitles,
  ThContainer,
  Trheader,
  ProjectFilterContainer,
  SelectStyle,
  Title,
  Description,
  TitleConatiner,
};

export default SC;
